import { render, staticRenderFns } from "./KuaiShou.vue?vue&type=template&id=d4eca8ba&scoped=true"
import script from "./KuaiShou.vue?vue&type=script&lang=js"
export * from "./KuaiShou.vue?vue&type=script&lang=js"
import style0 from "./KuaiShou.vue?vue&type=style&index=0&id=d4eca8ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4eca8ba",
  null
  
)

export default component.exports